export const formatPrice = (
	price: number | string | null | undefined,
	currency?: string,
): string => {
	const numeric = typeof price === "string" ? Number(price) : price;
	if (
		numeric === null ||
		numeric === undefined ||
		numeric === 0 ||
		Number.isNaN(numeric)
	)
		return "無料";
	const formatted = numeric.toLocaleString("ja-JP", {
		maximumFractionDigits: 0,
	});
	return currency ? `${formatted} ${currency}` : `¥${formatted}`;
};
